<div class="jur">
  <mat-progress-bar *ngIf="loading || busy" mode="indeterminate"></mat-progress-bar>

  <div *ngIf="error" class="jur__error">{{ error }}</div>

  <mat-card class="jur__card">
    <h2 class="jur__title"><mat-icon>account_balance</mat-icon> Jurisdiction commissions</h2>
    <p class="jur__muted">Set the collection-commission rate retained by each jurisdiction and toggle whether
      it participates in distribution runs. Jurisdictions added here also populate the
      municipality select taxpayers see when adding a property.</p>

    <div class="jur__add">
      <input type="text" [(ngModel)]="newName" placeholder="Jurisdiction / municipality name" class="jur__add-name">
      <input type="number" step="0.0001" [(ngModel)]="newRate" placeholder="Commission rate (e.g. 0.0075)"
             class="jur__rate">
      <button mat-flat-button color="primary" [disabled]="busy || !newName.trim()" (click)="add()">
        <mat-icon>add</mat-icon> Add jurisdiction
      </button>
    </div>

    <table class="jur__table" *ngIf="jurisdictions.length; else empty">
      <thead>
        <tr><th>Jurisdiction</th><th>Code</th><th>Commission rate</th><th>Active</th><th></th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let j of jurisdictions">
          <td>{{ j.name }}</td>
          <td>{{ j.code }}</td>
          <td>
            <input type="number" step="0.0001" [(ngModel)]="j.commissionRate" class="jur__rate">
            ({{ j.commissionRate * 100 | number:'1.2-4' }}%)
          </td>
          <td><input type="checkbox" [(ngModel)]="j.active"></td>
          <td>
            <button mat-button color="primary" [disabled]="busy" (click)="save(j)">Save</button>
            <span *ngIf="savedId === j.id" class="jur__saved"><mat-icon>check</mat-icon> Saved</span>
          </td>
        </tr>
      </tbody>
    </table>
    <ng-template #empty><p class="jur__muted">No jurisdictions configured.</p></ng-template>
  </mat-card>
</div>
